import { useNavigate } from "react-router-dom";

const NoProbe = ({ onBuyLicense }: { onBuyLicense?: () => void }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col grow justify-center items-center mt-12 font-space-grotesk">
      {/* Faded angular gradient with image */}
      <div className="relative flex items-center justify-center mb-8">
        <div
          className="absolute rounded-full bg-angular-gradient w-[320px] h-[320px] pt-14 -top-20"
          style={{
            opacity: 0.5,
            filter: 'blur(20px)'
          }}
        />
        <img
          src="/license-purchase-ultrasound.svg"
          alt="No licenses"
          className="relative z-10 h-[220px] object-contain"
        />
      </div>
      <h2 className="text-2xl font-bold mb-2 text-center z-50">Ready to get started?</h2>
      <p className="text-base text-gray-500 mb-2 text-center z-50">
        Buy your first license and enjoy everything HeartFocus offers.
      </p>
      <div className="flex justify-center items-center bg-angular-gradient w-full md:w-fit rounded-full p-0.5 mt-3">
        <button
          onClick={() => navigate("/purchase")}
          className="w-full md:w-fit font-semibold bg-white-a700 rounded-full text-base px-8 py-2 hover:bg-light-angular-gradient"
        >
          Buy License
        </button>
      </div>
    </div>
  );
};

export default NoProbe;